import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface FirebaseEvent {
  eventType: string;                 // 'gallery_folder_ready', 'document_ready', etc.
  moduleId:  number | null;
  modelId:   number | null;
  raw:       Record<string, string>; // full payload for any extra fields
}

/**
 * Handles all Firebase data-only event signals.
 * FirebaseMessagingService passes raw FCM data here; components subscribe to
 * the events$ observable and filter by eventType.
 *
 * To add a new event type: just send the correct payload from the backend
 * and filter by the new eventType in your component — no changes needed here.
 */
@Injectable({
  providedIn: 'root',
})
export class FirebaseEventService {
  private events$ = new Subject<FirebaseEvent>();

  /** Observable that any component can subscribe to and filter by eventType. */
  public events = this.events$.asObservable();

  /**
   * Called by FirebaseMessagingService when a firebase_type === 'event' message arrives.
   * Parses the raw FCM data payload and emits on the events$ stream.
   */
  dispatch(data: Record<string, string>): void {
    // sendEvent() payloads use 'model_id'; the notification helpers' routing
    // metadata uses 'data_id' for the same thing. Accept either so module-scoped
    // listeners get a record id from both sources.
    const modelId = data['model_id'] ?? data['data_id'];

    this.events$.next({
      eventType: data['event_type'] ?? '',
      moduleId:  data['module_id'] != null ? Number(data['module_id']) : null,
      modelId:   modelId != null ? Number(modelId) : null,
      raw:       data,
    });
  }
}
